import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import Spinner from "../components/Spinner";
//
const CreateProduct = () => {
  const [local, setLocal] = useState("");
  const [priceInCents, setPriceInCents] = useState("");
  const [evento, setEvento] = useState("");
  const [tags, setDescription] = useState("");
  const [img, setImg] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);
  const [imgName, setImgName] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [atletas, setAtletas] = useState([]);
  const [filteredAtletas, setFilteredAtletas] = useState([]);
  const [selectedAtleta, setSelectedAtleta] = useState(null); // Armazenando o objeto completo da atleta
  const [searchTerm, setSearchTerm] = useState(""); // Para armazenar o termo de busca

  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const imgFullRef = useRef(null);

  // Consultar a lista de atletas quando o componente é montado
  useEffect(() => {
    const fetchAtletas = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`,
          config
        );
        setAtletas(response.data.data); // Armazenar a lista de atletas
        setFilteredAtletas(response.data.data); // Inicializa a lista filtrada com todos os atletas
      } catch (error) {
        console.error("Erro ao buscar atletas:", error);
      }
    };
    fetchAtletas();
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);

    // Filtra os atletas com base no nome e os ordena em ordem alfabética
    const filtered = atletas
      .filter((atleta) => atleta.nome.toLowerCase().includes(query))
      .sort((a, b) => a.nome.localeCompare(b.nome)); // Ordenação alfabética

    setFilteredAtletas(filtered);
  };

  const handleSelect = (event) => {
    const selectedId = event.target.value;
    const selectedAtleta = atletas.find((atleta) => atleta._id === selectedId);
    setSelectedAtleta(selectedAtleta); // Atualiza o estado com o objeto completo da atleta
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setImg(selectedFile);
    setEvento(selectedFile.name.split(" ; ")[0]);
    setLocal(selectedFile.name.split(" ")[1]);
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImgPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setImgPreview(null);
    }
  };

  const uploadFile = async () => {
    if (!img) {
      enqueueSnackbar("Selecione as duas imagens", { variant: "warning" });
      return;
    }

    const data = new FormData();
    data.append("file", img);

    try {
      const uploadUrl = `${
        import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
      }/upload-image`;

      const res = await axios.post(uploadUrl, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      enqueueSnackbar("Image uploaded successfully", { variant: "success" });

      return res.data.results;
    } catch (error) {
      console.error("Upload error", error);
      enqueueSnackbar("Failed to upload an image", { variant: "error" });
    }
  };

  const handleSaveProduct = async () => {
    if (!priceInCents || !evento) {
      enqueueSnackbar("Please fill all required fields", {
        variant: "warning",
      });
      return;
    }

    const price = parseInt(priceInCents);
    if (isNaN(price) || price <= 0) {
      enqueueSnackbar("Price must be a positive number", {
        variant: "warning",
      });
      return;
    }

    setLoading(true);

    try {
      const uploadedImageUrls = await uploadFile();
      const { image, imageSample } = uploadedImageUrls;

      const formData = {
        local: !local ? imgName : local,
        priceInCents,
        tags,
        image,
        imageSample,
        evento,
        atletaId: selectedAtleta?._id, // Enviar o ID da atleta
        atletaNome: selectedAtleta?.nome, // Enviar o nome da atleta
      };

      await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product`,
        formData,
        config
      );

      enqueueSnackbar("Product saved successfully", { variant: "success" });
      // navigate("/admin");
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(
        "Error saving product: " +
          (error.response?.data?.message || error.message),
        {
          variant: "error",
        }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-base-100 grid lg:space-x-4 justify-center items-start mt-16 lg:flex">
      {loading && <Spinner />}

      <div className="container max-w-sm shadow-lg rounded-lg p-5 bg-base-100">
        <h1 className="text-2xl font-semibold my-4">Dados das fotos fotos</h1>
        <div className="my-4">
          <label htmlFor="local" className="block text-md mb-2">
            Local*
          </label>
          <input
            id="local"
            type="text"
            value={local || ""}
            onChange={(e) => setLocal(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
            required
          />
          <label htmlFor="priceInCents" className="block text-md mb-2">
            Preço em centavos*
          </label>
          <input
            id="priceInCents"
            type="number"
            value={priceInCents || ""}
            onChange={(e) => setPriceInCents(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
            required
          />
          <label htmlFor="tags" className="block text-md mb-2">
            Tags
          </label>
          <input
            id="tags"
            type="text"
            value={tags || ""}
            onChange={(e) => setDescription(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />
          <label htmlFor="evento" className="block text-lg mb-2 mt-4">
            Evento*
          </label>
          <input
            id="evento"
            type="text"
            value={evento || ""}
            onChange={(e) => setEvento(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
            required
          />
          <div>
            <label htmlFor="atleta">Atleta</label>
            <input
              id="atleta"
              type="text"
              value={searchTerm || ""}
              onChange={handleSearch}
              placeholder="Digite o nome do atleta"
              className="border px-4 py-2 w-full mb-2"
            />

            <select
              id="atleta-select"
              value={selectedAtleta?._id || ""}
              onChange={handleSelect}
              className="border px-4 py-2 w-full"
            >
              <option value="">Selecione uma atleta</option>
              {filteredAtletas.length > 0 ? (
                filteredAtletas.map((atleta, index) => (
                  <option
                    key={atleta._id || index}
                    value={atleta._id} // Usando o ID da atleta como valor
                  >
                    {atleta.nome}
                  </option>
                ))
              ) : (
                <option disabled>Não há atletas correspondentes</option>
              )}
            </select>
          </div>
          <input
            id="imgFull"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full border mt-4 border-base-300 px-4 py-2 rounded-md"
            required
            ref={imgFullRef}
          />
          <h3 htmlFor="Modelo">
            Modelo: 2024-11-01 Pinheiros vs Osasco ; 2024_11_01 - DSC00424{" "}
          </h3>
          <h4 htmlFor="Modelo2">Local = após segundo espaço </h4>{" "}
          <h4>Evento = até ;</h4>
          <button
            onClick={handleSaveProduct}
            className="w-full bg-green-500 hover:bg-green-800 text-white py-2 px-4 rounded-md mt-4"
          >
            Salvar
          </button>
          <Link to="/admin" className="btn mt-5">
            Voltar
          </Link>
        </div>
      </div>

      <div className="container max-w-[555px] shadow-lg rounded-lg p-5 min-h-[555px] bg-base-100">
        <h1 className="text-2xl font-semibold my-4">Preview</h1>
        <div className="flex space-x-4">
          <div className="my-2 ">
            {imgPreview && (
              <div className="my-4">
                <img
                  src={imgPreview}
                  alt="Preview"
                  className="max-w-full h-auto"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProduct;
